export default __webpack_public_path__ + "static/media/logo-sumbar.1e1be41a.svg";